module.exports = __webpack_public_path__ + "static/parc-a226f87324b836127d023e84d9ae378c.jpg";